<div class="rounding-figure-wrapper">
  <form [formGroup]="roundingFigureForm">
    <div class="rounding-form-row">
      <mat-checkbox
        formControlName="manageAutoRoundingValues"
        (change)="onManageAutoRoundingChange($event.checked)"
      >
        Manage auto rounding values
      </mat-checkbox>
      <button
        class="action-button primary-button"
        mat-button
        disableRipple
        [disabled]="!roundingFigureForm.controls.manageAutoRoundingValues.value"
        (click)="openAddDialog()"
      >
        <span>+ Add</span>
      </button>
    </div>
  </form>

  <div class="mat-table-wrapper mt-2">
    <table mat-table [dataSource]="dataSource" aria-describedby="rounding-figures-grid">
      <ng-container matColumnDef="profitLossAccount">
        <th mat-header-cell *matHeaderCellDef>SOFA Accounts</th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex align-items-center">
            <span class="onelineclamp" title="{{ element.profitLossAccountName }}">
              {{element.profitLossAccountName}}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="balanceSheetAccount">
        <th mat-header-cell *matHeaderCellDef>Balance sheet Accounts</th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex align-items-center">
            <span class="onelineclamp" title="{{ element.balanceSheetAccountName }}">
              {{element.balanceSheetAccountName}}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="fund">
        <th mat-header-cell *matHeaderCellDef>Fund</th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex align-items-center">
            <span class="onelineclamp" title="{{ element.fundName }}">
                {{element.fundName}}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="period">
        <th mat-header-cell *matHeaderCellDef>Period</th>
        <td mat-cell *matCellDef="let element">
          <div class="d-flex align-items-center">
            <span class="onelineclamp" title="{{ element.periodName }}">
              {{ element.periodName || '-' }}
            </span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="w-100">Actions</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <div
            class="grid-actions"
          >
            <button
              mat-button
              type="button"
              aria-label="Edit"
              (click)="editRow(element)"
            >
              <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
            </button>
            <button
              mat-button
              type="button"
              aria-label="Delete"
              (click)="deleteRow(element)"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-align-center" [attr.colspan]="displayedColumns.length">
          No records found
        </td>
      </tr>
    </table>
  </div>
</div>
